import axios, {AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse} from 'axios';
import * as _ from 'lodash';
import {APIService} from './api.service';

export class APIServiceImpl implements APIService {
  service: AxiosInstance;
  constructor() {
    this.service = axios.create({baseURL: process.env.REACT_APP_API_BASE_URL});

    this.service.interceptors.response.use(
      (response): AxiosResponse => response,
      (error): Promise<AxiosError> => Promise.reject(error),
    );
  }

  protected static parseError(response: AxiosResponse): string {
    return _.get(response, 'response.data.error', '');
  }

  protected async get(path: string, config?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.service.get(path, config);
  }

  protected async post(path: string, payload: any, config?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.service.post(path, payload, config);
  }

  protected async put(path: string, payload: any, config?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.service.put(path, payload, config);
  }

  protected async patch(path: string, payload: any, config?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.service.patch(path, payload, config);
  }

  protected async delete(path: string, config?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.service.delete(path, config);
  }
}
